<script setup lang="ts">
    import type { IWidgetProps } from '~/composables/widgets';
    import type { HeroSliderData } from '~/@types/cms';

    defineProps<IWidgetProps<HeroSliderData>>();
</script>
<template>
    <org-hero-slider
        class="cms-hero-slider"
        :component-index="componentIndex"
        :data="data.value.components"
        :settings="data.settings" />
</template>
